import DeliveryRegion from '@/models/DeliveryRegion';

export default class DeliveryRegionRepository {
    public static getAll() {
        return DeliveryRegion.all();
    }

    public static getById(id: string) {
        return DeliveryRegion.query().whereId(id).withAll().first();
    }
}
